import React from 'react';

export default function AttachmentRow(props) {
  const { attachment } = props;
  return (
    <div className="link-attachment-name">
      {!attachment?.is_link ? (
        <a href={attachment?.url} download={attachment?.name}>
          {attachment?.name}
        </a>
      ) : (
        <>{attachment?.name}</>
      )}
    </div>
  );
}
